// ! FIX ME: Refactor this
import {
  JsonApiQueryParameters,
  formatQueryForJsonApi,
  transformResponseFromJsonApi,
} from '@evolve/common-ui';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders } from 'evolve-ui';

export type ICustomer = {
  id: string;
  name: string;
  number: string;
};

// Define a service using a base URL and expected endpoints
export const communicationsCustomersApi = createApi({
  reducerPath: 'customers',
  baseQuery: fetchBaseQuery({
    // ! FIX ME: Change this
    baseUrl: `${process.env.GATSBY_COMMUNICATIONS_API_URL}/customers`,
    mode: 'cors',
    prepareHeaders,
  }),
  tagTypes: ['Customer'],
  endpoints: (builder) => ({
    getCustomers: builder.query<
      { values: ICustomer[] },
      JsonApiQueryParameters
    >({
      providesTags: ['Customer'],
      query: formatQueryForJsonApi,
      transformResponse: transformResponseFromJsonApi<ICustomer>,
    }),
  }),
});

export const { useGetCustomersQuery } = communicationsCustomersApi;
